import axios from 'axios';
import { curry, mergeRight, omit, propOr } from 'ramda';

export const cleanPatchPayload = data =>
  data instanceof FormData ? data : omit(['id', 'is_deleted', 'shop'], data);

export const api = {
  delete: url =>
    axios({
      method: 'DELETE',
      url,
    }),

  get: (url, optional = {}) =>
    axios(
      mergeRight(
        {
          method: 'GET',
          url,
        },
        optional,
      ),
    ),

  patch: (url, data, config = {}) =>
    axios({
      method: 'PATCH',
      url,
      data: cleanPatchPayload(data),
      config,
    }),

  post: (url, data, config = {}) =>
    axios({
      method: 'POST',
      url,
      data,
      config,
    }),
};

export const fetchParams = (state, payload = {}, filters = {}) => {
  return mergeRight(
    {
      limit: payload.limit || state.pagination.limit,
      skip: payload.skip || state.pagination.skip,
      search: propOr(null, 'search', payload),
      sortBy: propOr('updatedAt', 'sortBy', payload),
      sortDesc: propOr(true, 'sortDesc', payload),
    },
    filters,
  );
};

export const fetchResponse = data => {
  return {
    items: data.data,
    pagination: {
      pages: data.pages,
      limit: data.limit,
      skip: data.skip,
      count: data.count,
    },
  };
};

export const setter = curry((state, payload) =>
  Object.assign(state, mergeRight(state, payload)),
);
